import type { Components } from '@mui/material/styles';

export default function MUINativeSelect(): Components['MuiNativeSelect'] {
  return {};
}
